import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { Dialog, DialogPropertyValues, IDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Dialog";
import { UserNotificationList } from "../Controls/UserNotificationList";
import { NAMESPACE } from "./_Namespace";

import "./UserNotificationDialog.scss";

export type UserNotificationDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type UserNotificationDialogProperties = {
    [name in keyof UserNotificationDialogPropertyValues]: Property<UserNotificationDialogPropertyValues[name]>
};

export interface IUserNotificationDialog extends IDialog, UserNotificationDialogProperties
{
}

export class UserNotificationDialog extends Dialog implements IUserNotificationDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "UserNotificationDialog";
    public static override className = "UserNotificationDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<UserNotificationDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                blockNavigation: false,
                okButtonText: "Close",
                scrollable: false,
                title: "Notifications",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    protected userNotificationList?: UserNotificationList;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<UserNotificationDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.userNotificationList =
            new UserNotificationList({ dialog: this })
                .appendTo(this._containerElementRef.current);

        return $$element;
    }
    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-user-notification-dialog");
    }
    public override async openAsync()
    {
        Assert.isNotNullOrUndefined(this.userNotificationList, "this.userNotificationList");

        await this.userNotificationList.loadDataAsync();
        return super.openAsync();
    }

    // #endregion

    // #endregion
}
